import Axios from 'axios';
import Qs from 'qs';

export default {

  // 帖子分页列表
  listPage(
    community_id,
    keyword,
    nickname,
    category_id,
    page,
    per_page
  ) {
    return Axios.get('/llhd/api/admin/posts', {
      params: {
        community_id,
        keyword,
        nickname,
        category_id,
        page,
        per_page
      },
      paramsSerializer(params) {
        return Qs.stringify(params);
      }
    })
  },

  // 帖子添加
  add(
    category_id,
    community_ids,
    content,
    photos
  ) {
    return Axios.post('/llhd/api/admin/posts', {
      category_id,
      community_ids,
      content,
      photos
    });
  },

  // 帖子详情
  info(
    id,
    page,
    per_page
  ) {
    return Axios.get(`/llhd/api/admin/posts/${id}`, {
      params: {
        page,
        per_page
      }
    });
  },

  // 帖子置顶
  top(
    id
  ) {
    return Axios.post(`/llhd/api/admin/posts/${id}/top`, {
      is_top: 1
    });
  },

  // 帖子取消置顶
  cancelTop(
    id
  ) {
    return Axios.post(`/llhd/api/admin/posts/${id}/top`, {
      is_top: 0
    });
  },

  // 帖子启用
  enable(
    id
  ) {
    return Axios.post(`/llhd/api/admin/posts/${id}/hide`, {
      is_hide: 0
    });
  },

  // 帖子禁用
  disable(
    id
  ) {
    return Axios.post(`/llhd/api/admin/posts/${id}/hide`, {
      is_hide: 1
    });
  },

  // 帖子评论
  comment(
    community_id,
    id,
    content
  ) {
    return Axios.post(`/llhd/api/admin/posts/${id}/comment`, {
      community_id,
      content
    });
  },

  // 帖子点赞
  like(
    id
  ) {
    return Axios.post(`/llhd/api/admin/posts/${id}/like`);
  }

}